module.exports = __webpack_public_path__ + "img/portrait.24db9830.jpg";